import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { SkuDataComponent } from './sku-data.component';

@NgModule({
  imports: [
    CommonModule,
    MatTabsModule
  ],
  declarations: [
    SkuDataComponent
  ],
  exports: [
    SkuDataComponent
  ],
})
export class SkuCapsuleFeatureSkuDataModule {}
